<template>
    <div class="h-full relative">
        <img
            class="loading absolute"
            src="https://abroad-sin-static.shengqugames-corp.com/wpay/icon_loading.png"
            alt="loading"
        />
    </div>
</template>

<script>
/* eslint-disable camelcase */
// 专门给 webview 和 android 进行三方登录的页面，在此获取 OAuth 参数（因为 webview 三方登录页面是他们自己实现的）
import Vue from 'vue';
import { mapState } from 'vuex';
import { Toast } from 'vant';
import { OAuths, OAuthKey } from '@/enums';
import { getUidV4, queryConcat } from '@/lib/utils';
import { getTwitterRequestToken } from '@/api/oauth';

Vue.use(Toast);

export default {
    data() {
        return {
            // logs: { web_pageid: 'ghome-web-oauth-iframe' },
            key: '',
        };
    },
    computed: { ...mapState(['platform']) },
    created() {
        const { key } = this.$route.params;
        const { appId, redirect_uri } = this.$route.query;
        if (!key) return this.$toast('No key parameter');
        if (!appId) return this.$toast('No appId parameter');
        if (!this.platform) return this.$toast('No platform parameter');
        if (key !== OAuthKey.Twitter && !redirect_uri) {
            return this.$toast('No redirect_uri parameter');
        }
        this.key = key;
    },
    mounted() {
        window.addEventListener('load', this.openOAuth);
    },
    beforeDestroy() {
        window.removeEventListener('load', this.openOAuth);
    },
    methods: {
        // 打开三方授权
        async openOAuth() {
            if (this.key) {
                const query = await this.getOAuthQuery(this.key);
                window.location.href = OAuths[this.key].url + query;
            }
        },

        // 准备对应的 OAuth URL 配置
        async getOAuthQuery(key) {
            const { client_id, redirect_uri } = this.$route.query;
            const query = {
                state: getUidV4(),
                client_id,
                redirect_uri,
            };

            switch (key) {
                case OAuthKey.Google:
                    return queryConcat({
                        ...query,
                        response_type: 'token',
                        scope: 'https://www.googleapis.com/auth/userinfo.profile',
                        prompt: 'select_account',
                    });
                case OAuthKey.Facebook:
                    return queryConcat({
                        ...query,
                        response_type: 'token', // token 将以片段方式返回口令
                    });
                case OAuthKey.Apple:
                    return queryConcat({
                        ...query,
                        response_type: 'code id_token',
                        response_mode: 'fragment',
                    });
                case OAuthKey.Line:
                    return queryConcat({
                        ...query,
                        response_type: 'code',
                    });
                case OAuthKey.Twitter: {
                    // Twitter1.0 单独处理，web 自行获取 request_token 等参数
                    try {
                        const { requestToken: oauth_token } = await getTwitterRequestToken();
                        return queryConcat({ oauth_token });
                    } catch (e) {
                        const error = e.data || {
                            code: -1,
                            msg: 'get twitter token failed',
                            data: null,
                        };
                        this.webviewCallback(error);
                        return Promise.reject(error);
                    }
                }
                default:
                    return '';
            }
        },
        webviewCallback(payload = {}) {
            // AuthCallback 不能及时拿到，暂时先加个延时
            setTimeout(() => {
                try {
                    window.AuthCallback(payload);
                } catch (e) {
                    console.error(e);
                }
            }, 800);
        },
    },
};
</script>

<style scoped>
.loading {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
